module.exports = __webpack_public_path__ + "img/planet3.600289d3.png";